<template>
  <div class="RecordingBucketBrowser default-color">
    <b-container>
      <RecordingTreeView v-bind:tree-data="recordingTreeData"/>
    </b-container>
  </div>
</template>

<script>
  import RecordingTreeView from './RecordingTreeView/RecordingTreeView'

  export default {
    components: { RecordingTreeView },
    props: ['recordingBucketData'],
    data () {
      return {
        recordingTreeData: []
      }
    },
    created () {
      let context = this
      this.recordingBucketData.forEach((item, index) => {
        let formattedRecordingData = {}
        formattedRecordingData.size = item.size
        formattedRecordingData.name = item.key
        formattedRecordingData.key = item.key
        formattedRecordingData.etag = item.etag
        formattedRecordingData.isInTree = false
        formattedRecordingData.children = []

        this.checkParentExists(context, formattedRecordingData, this.recordingTreeData)
      })

    },
    methods: {
      checkParentExists: (context, formattedRecordingData, treeDataArray) => {
        if (formattedRecordingData.name === '') {
          return
        }
        if (treeDataArray.length === 0 && formattedRecordingData.name !== '') {
          context.pushToTreeDataArray(treeDataArray, formattedRecordingData)
        } else {
          let parentTreeDataItem = null
          let matchFound = false
          treeDataArray.forEach((treeDataItem) => {

            if (formattedRecordingData.name.lastIndexOf(treeDataItem.name) !== -1) {
              matchFound = true
              parentTreeDataItem = treeDataItem
            }
          })

          if (matchFound) {
            formattedRecordingData.name = formattedRecordingData.name.slice(parentTreeDataItem.name.length, formattedRecordingData.name.length)
            if (formattedRecordingData.name.length && !formattedRecordingData.isInTree) {
              context.checkParentExists(context, formattedRecordingData, parentTreeDataItem.children)
            }
          } else {
            context.pushToTreeDataArray(treeDataArray, formattedRecordingData)
          }

        }
      },
      pushToTreeDataArray (treeDataArray, formattedRecordingData) {
        treeDataArray.push(formattedRecordingData)
        formattedRecordingData.isInTree = true
      }

    }
  }
</script>

